import { GhostButtonNeutral } from 'rwl-ui';
import { PhoneSVG } from '../../../themes/icons';
import { HideOnMDScreen } from '../HideOnMDScreen';
import { useEnqueueEngagement } from '../../../hooks';
import { ConversionType } from 'rwl-shared/dist/models/plugin/Conversion';

type SharePhoneProps = {
    phoneNumber?: string;
    mediaId?: string;
    workSiteId?: string;
};

function formatPhoneNumber(phoneNumber: string): string {
    const cleaned = phoneNumber.replace(/\D/g, '');
    const match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/);
    if (match) {
        return `(${match[1]}) ${match[2]}-${match[3]}`;
    }
    return phoneNumber;
}

export const SharePhone = ({
    phoneNumber,
}: SharePhoneProps): JSX.Element | null => {
    const { enqueue } = useEnqueueEngagement();

    if (!phoneNumber) {
        return null;
    }

    return (
        <GhostButtonNeutral
            href={`tel:${phoneNumber}`}
            className={'sharePhone'}
            onClick={() => {
                enqueue({
                    type: 'Conversion',
                    conversionType: ConversionType.Phone,
                    target: 'Share Phone CTA',
                    clickedAt: new Date(),
                    pageUrl: window.location.href,
                });
            }}
        >
            <PhoneSVG />
            <HideOnMDScreen>{formatPhoneNumber(phoneNumber)}</HideOnMDScreen>
        </GhostButtonNeutral>
    );
};
